var React = require('react');

function VideoControlsForwardInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M12.6283 5.00977V18.9812L23.5 11.9955L12.6283 5.00977Z","fill":"currentColor","key":0}),React.createElement("path",{"d":"M1.5001 5.00977V18.9812L12.3718 11.9955L1.5001 5.00977Z","fill":"currentColor","key":1})]);
}

VideoControlsForwardInline.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = VideoControlsForwardInline;

VideoControlsForwardInline.default = VideoControlsForwardInline;
